<template>
    <div class="col-lg-10" ref="next">
        <h6 class="heading-small text-muted mb-4">{{ index+1 }}. {{ question.question }}</h6>
        <span class="text-sm">{{ question.description }}</span>
        <div v-if="question.type === 'number'" >
            <base-input :ref="'a'+index"
                        autofocus
                        :valid="answers[index].answer.length > 0"
                        type="number"
                        v-model="answers[index].answer[0]"
                        :disabled="!answers[index].edit"
                        placeholder="Bitte Antwort eingeben"
                        input-classes="form-control-alternative"></base-input>
        </div>
        <div v-if="question.type === 'text'" >
            <base-input :ref="'a'+index"
                        autofocus
                        :valid="answers[index].answer.length > 0"
                        v-model="answers[index].answer[0]"
                        :disabled="!answers[index].edit"
                        placeholder="Bitte Antwort eingeben"
                        input-classes="form-control-alternative"></base-input>
        </div>
        <div v-if="question.type === 'multiple'" >
            <div v-for="(answer,i) in question.answers" :key="i">
                <b-form-checkbox :ref="'a'+index"
                                 v-model="answers[index].answer"
                                 :name="'check'+index"
                                 style="margin-bottom: 1rem; width: 100%;"
                                 :disabled="!answers[index].edit"
                                 :value="answer"
                                 button-variant="outline-primary"
                                 outline
                                 button>
                    {{answer}} <b> <i v-if="answers[index].answer.includes(answer)" class="fas fa-check"></i> </b>
                </b-form-checkbox>
            </div>
        </div>
        <div v-if="question.type === 'single'">
            <div >
                <b-form-radio-group
                        :ref="'a'+index"
                        autofocus
                        required
                        :id="'q'+index+'-radio'"
                        v-model="answers[index].answer[0]"
                        :disabled="!answers[index].edit"
                        :options="options"
                        button-variant="outline-primary"
                        outline
                        buttons
                        style="width: 100%;"
                        name="radios-btn-default"
                        stacked
                >
                    <b-form-radio v-for="(answer,i) in question.answers" :key="i"
                                     name="check-button"
                                     style="margin-bottom: 1rem; width: 100%; text-align: left;"
                                     :value="answer"
                                     button>
                        {{answer}} <b> <i v-if="answers[index].answer.includes(answer)" class="fas fa-check"></i> </b>
                    </b-form-radio>
                </b-form-radio-group>
            </div>
        </div>
        <div v-if="question.extra">
            <base-input v-model="answers[index].extra"
                        :disabled="!answers[index].edit"
                        placeholder="Bitte Antwort eingeben"
                        input-classes="form-control-alternative"></base-input>
        </div>
        <hr class="my-4"/>
    </div>
</template>
<script>
    export default {
        name: 'QuestionsAndAnswers',
        props: {
            answers: {},
            index: {},
            question: {}
        },
        data() {
            return {
                options: [],
                isMounted: false
            }
        },
        mounted() {
          this.isMounted = true
        },
        computed: {
            valid(index) {
                return (this.isMounted) ? this.answers[index].answer.length > 0 : false;
            }
        }
    }
</script>
<style>
    div.btn-group-toggle > label {
        width: 100%;
        text-align: left;
    }
</style>